import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetCheckingAccountClientDetailCommand extends IRequestCommand<
  IGetCheckingAccountClientDetailResponse,
  ErrorDetails,
  IGetCheckingAccountClientDetailParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = "magiisBook/carrier/{carrierId}/client/{paxId}/dashboard?dateFrom={dateFrom}&dateTo={dateTo}"

  public override setParameters(parameters: IGetCheckingAccountClientDetailParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId ? parameters.carrierId.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{paxId}',
      parameters.paxId ? parameters.paxId.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{dateFrom}',
      parameters.dateFrom ? parameters.dateFrom.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{dateTo}',
      parameters.dateTo ? parameters.dateTo.toString() : ''
    );
  }
}

export interface IGetCheckingAccountClientDetailParameters {
    carrierId: number;
    paxId?: number;
    dateFrom?: string;
    dateTo?: string;
}

export interface IGetCheckingAccountClientDetailResponse extends ICommandResponse, MBClientSummaryDTO {
}

// Reutilizable (Java BigDecimal -> number; Long -> number)
export interface AmountQuantityDTO {
  amount: number;   // monto (ej. BigDecimal en Java)
  quantity: number; // cantidad (ej. Long en Java)
}

// Detalle de movimientos/elementos del cliente
export interface MBClientDetailDTO {
  creationDate: string | Date; // ISO string o Date si lo parseás
  id: number;
  idForCarrier: number;
  code: string;
  amount: number;
  currency: string;
  observations?: string; // puede venir null/undefined
  status: string;        // podés tiparlo con un enum si tenés el set de estados
}

// Raíz del payload
export interface MBClientSummaryDTO {
  current: AmountQuantityDTO;

  saleOrdersNotPaid: AmountQuantityDTO;
  saleOrdersPaid: AmountQuantityDTO;
  saleOrdersExpired: AmountQuantityDTO;

  invoicesPaid: AmountQuantityDTO;
  invoicesNotPaid: AmountQuantityDTO;
  invoicesExpired: AmountQuantityDTO;

  paymentsOpened: AmountQuantityDTO;
  paymentsCleared: AmountQuantityDTO;

  salesTickets: AmountQuantityDTO; //Total
  salesTicketsCash: AmountQuantityDTO;
  salesTicketsCC: AmountQuantityDTO;
  salesTicketsQR: AmountQuantityDTO;

  details: MBClientDetailDTO[];
}